export class Audioplayer
{
    constructor(audioPlayer)
    {
        this.container = audioPlayer.closest('figure');
        this.container.classList.add('initialized');
        this.playButton = this.container.querySelector('.w__audio--play');
        this.time = this.container.querySelector('.w__audio--time');
        this.duration = this.container.querySelector('.w__audio--duration');
        this.timelinePointer = this.container.querySelector('.w__audio--timeline-pointer');
        this.audio = audioPlayer;
        this.add_events();
        this.playing = false;
    }

    add_events()
    {
        if(this.audio.readyState)
        {
            this.set_duration();
        }
        else
        {
            this.audio.addEventListener('loadedmetadata', () =>
            {
                this.set_duration();
            });
        }

        this.audio.addEventListener('ended',() =>
        {
            this.toggle_play(true);
            this.set_time();
        });

        this.audio.addEventListener('timeupdate',() =>
        {
            this.set_time();
        });

        this.container.addEventListener('click',e =>
        {
            const el = e.target;
            if(el.classList.contains('w__audio--control'))
            {
                switch(el.dataset.f)
                {
                    case 'ff':
                        this.seek_position(15);
                        break;

                    case 'fr':
                        this.seek_position(-15);
                        break;

                    case 'play':
                        this.toggle_play();
                        break;
                }
            }
            else if(el.classList.contains('w__audio--timeline'))
            {
                this.set_position((e.clientX - el.getBoundingClientRect()['left']) * 100
                                   / el.getBoundingClientRect()['width']);
            }
        });
    }

    convert_time(seconds)
    {
        return Math.floor(seconds / 60) + ':' + ('00' + Math.floor(seconds % 60)).slice(-2);
    }

    set_duration()
    {
        this.duration.textContent = this.convert_time(this.audio.duration);
    }

    set_position(percent)
    {
        this.audio.currentTime = this.audio.duration * percent / 100;
        this.set_time();
    }

    seek_position(seconds)
    {
        this.audio.currentTime += seconds;
        this.set_time();
    }

    set_time()
    {
        this.time.textContent = this.convert_time(this.audio.currentTime);
        this.set_timelinePointer();
    }

    set_timelinePointer()
    {
        let percent = this.audio.currentTime * 100 / this.audio.duration;
        this.timelinePointer.style.left = percent.toString() + '%';
    }

    toggle_play(forceOff)
    {
        if(this.playing === true || forceOff === true)
        {
            this.audio.pause();
            this.playing = false;
            this.container.classList.remove('playing');
            if(forceOff === true)
            {
                this.audio.currentTime = 0;
            }
        }
        else
        {
            this.audio.play();
            this.playing = true;
            this.container.classList.add('playing');
            this.set_duration();
        }
    }
}